import { forwardRef, useState, useRef, useEffect } from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../utils/imageHelper";



/*eslint-disable */

declare const window: any;

interface TecnologiaVehiculosComponentProps {
  tecnologias: any;
}

const TecnologiaVehiculosComponent = forwardRef<
  HTMLDivElement,
  TecnologiaVehiculosComponentProps
>(({ tecnologias }, ref) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // refs para items y contenedores
  const imageContainerRef = useRef<HTMLDivElement | null>(null);
  const infoContainerRef = useRef<HTMLDivElement | null>(null);
  const imageItemsRef = useRef<(HTMLDivElement | null)[]>([]);
  const infoItemsRef = useRef<(HTMLDivElement | null)[]>([]);

  // Función para centrar un item dentro de su contenedor
  const scrollToCenter = (
    container: HTMLDivElement | null,
    item: HTMLDivElement | null
  ) => {
    if (!container || !item) return;

    const containerRect = container.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();

    const offset =
      itemRect.left -
      containerRect.left +
      container.scrollLeft -
      container.clientWidth / 2 +
      itemRect.width / 2;

    container.scrollTo({
      left: offset,
      behavior: "smooth",
    });
  };

  // mover scroll cuando cambia el index
  useEffect(() => {
    scrollToCenter(
      imageContainerRef.current,
      imageItemsRef.current[currentIndex]
    );
    scrollToCenter(
      infoContainerRef.current,
      infoItemsRef.current[currentIndex]
    );
  }, [currentIndex]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : tecnologias?.tecnologia?.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < tecnologias?.tecnologia?.length - 1 ? prevIndex + 1 : 0
    );
  };

  return (
    <div className="tecnologia-vehiculos-detail-component" ref={ref}>
      <div
        className="btn-carrousel-caracteristica-vehiculos-detail-component prev"
        onClick={handlePrev}
      >
        <img
          src="/assets/01_Home/Icon_Left.svg"
          alt="Ícono de flecha izquierda"
          width="40"
          height="40"
        />
      </div>

      <div
        className="carrousel-tecnologia-vehiculos-detail-component"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
          transition: "transform 0.5s ease", // animación
        }}
      >
        {tecnologias?.tecnologia?.map((item: any, index: number) => (
          <div
            className="item-tecnologia-vehiculos-detail-component"
            key={index}
          >
            {item?.media_type === "video" ? (
              <video
                src={buildCmsUrl(item?.media?.url)}
                autoPlay
                muted
                loop
                playsInline
                width="1200"
                height="675"
              />
            ) : (
              <img
                src={buildCmsUrl(item?.media?.url)}
                srcSet={getSrcSet(item?.media?.url || '')}
                sizes={getSizes('1200px')}
                alt={item?.title || "Imagen de tecnología del vehículo"}
                width="1200"
                height="675"
              />
            )}
          </div>
        ))}
      </div>

      <div
        className="btn-carrousel-caracteristica-vehiculos-detail-component next"
        onClick={handleNext}
      >
        <img
          src="/assets/01_Home/Icon_Right.svg"
          alt="Ícono de flecha derecha"
          width="40"
          height="40"
        />
      </div>

      <div
        ref={infoContainerRef}
        className="info-tecnologia-vehiculos-detail-component"
        style={
          tecnologias?.tecnologia?.length < 6
            ? { justifyContent: "center" }
            : {}
        }
      >
        {tecnologias?.tecnologia?.map((item: any, index: number) => (
          <div
            ref={(el) => (infoItemsRef.current[index] = el)}
            className={`item-info-tecnologia-vehiculos-detail-component ${
              index === currentIndex ? "active" : ""
            }`}
            onClick={() => setCurrentIndex(index)}
            key={index}
          >
            <div className="title-info-tecnologia-vehiculos-detail-component">
              {item.title}
            </div>
            <div className="descripcion-info-tecnologia-vehiculos-detail-component">
              {item.description}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default TecnologiaVehiculosComponent;
